import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import theme from '../../theme';
import { TouchableOpacity } from '../Touchables';

export const RADIO_HEIGHT = 24;

const RadioButton = ({
    isChecked,
    onCheck,
    isDisabled,
    style,
}: {
    isChecked: boolean;
    onCheck: () => void;
    isDisabled?: boolean;
    style?: React.CSSProperties;
}) => (
    <TouchableOpacity
        style={{
            width: RADIO_HEIGHT,
            height: RADIO_HEIGHT,
            borderRadius: RADIO_HEIGHT / 2,
            border: `2px solid ${
                isChecked ? 'transparent' : theme.colors.blue20
            }`,
            backgroundColor: isDisabled
                ? theme.colors.disabled
                : theme.colors.white,
            alignItems: 'center',
            justifyContent: 'center',
            ...style,
        }}
        onClick={!isDisabled ? onCheck : undefined}
        aria-checked={isChecked}
        aria-disabled={isDisabled}
        role="radio"
        tabIndex={0}
    >
        {isChecked ? (
            <RadioButtonCheckedIcon
                style={{
                    color: theme.colors.secondary,
                    width: RADIO_HEIGHT,
                    height: RADIO_HEIGHT,
                }}
            />
        ) : (
            <RadioButtonUncheckedIcon
                style={{
                    color: theme.colors.blue20,
                    width: RADIO_HEIGHT,
                    height: RADIO_HEIGHT,
                }}
            />
        )}
    </TouchableOpacity>
);

export default RadioButton;
